import { fromSatoshi } from '@lombard.finance/sdk';
import { getValidChain } from 'modules/api';
import { useConnection } from 'modules/auth';
import { useMemo } from 'react';
import { useGetWithdrawalStatusQuery } from 'modules/dashboard/actions/getWithdrawalStatus';

const WITHDRAWAL_REFETCH_INTERVAL = 20_000;

const prefixHash = (hash: string) => hash && `0x${hash}`;

export const useIsWithdrawalInProgress = () => {
  const { address, chainId: currentChainId } = useConnection();
  const {
    data: withdrawalStatus,
    isLoading,
    refetch,
  } = useGetWithdrawalStatusQuery(
    { address, chainId: getValidChain(currentChainId) },
    {
      pollingInterval: WITHDRAWAL_REFETCH_INTERVAL,
      skip: !address || !currentChainId,
    },
  );

  const { transactionHash, amount, deadline } = useMemo(() => {
    if (!withdrawalStatus) return {};

    const request = withdrawalStatus.open_requests[0] || withdrawalStatus.expired_requests[0] || {};
    const transactionHash = request?.transaction_hash;
    const amountSats = request?.amount;
    const deadline = request?.metadata?.secondsToDeadline;

    const amountLbtc = fromSatoshi(amountSats);

    return {
      transactionHash: prefixHash(transactionHash),
      amount: amountLbtc,
      deadline,
    };
  }, [withdrawalStatus]);

  return {
    isWithdrawalInProgress: !!transactionHash,
    refetch,
    transactionHash,
    deadline,
    amount,
    isLoading,
    chainId: currentChainId,
  };
};
